module.exports = __webpack_public_path__ + "static/media/sepordehBKG.a2cc1400.jpg";